import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import tessera_logo from './tessera.json';

const Tessera = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const anim = lottie.loadAnimation({
      container: ref.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: tessera_logo,
    });

    return () => anim.destroy();
  }, []);

  return <div ref={ref} style={{ width: 200, height: 200 }} />;
};

export default Tessera;
